<template>
    <div class="network-connect">
        <!-- <div class="dropdown network-dropdown mr-2" v-show="!hasWallet">
            <button
                v-if="!hasWallet"
                class="btn"
                type="button"
                id="dropdownMenuButton"
                style="width:100%;padding-left:10px;"
            >
                No Wallet Connected
            </button>
        </div>

        <div class="dropdown my-dropdown mr-2" v-show="hasWallet">
            <button
                class="btn"
                :class="canSwitchNetwork ? 'dropdown-toggle' : ''"
                type="button"
                id="dropdownMenuButton"
                :data-toggle="canSwitchNetwork ? 'dropdown' : ''"
                :aria-haspopup="canSwitchNetwork"
                aria-expanded="false"
                style="padding-left:10px;"
            >
                {{ selectedNetwork }}
            </button>
            <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton"
            >
                <a
                    class="dropdown-item"
                    style="text-align: center"
                    href="#"
                    @click="switchNetwork(item)"
                    v-for="(item, index) in getAvailableNetwork"
                    :key="index"
                >
                    {{ item.name }}
                </a>
            </div>
        </div> -->

        <div
            class="mobile-network-wallet__btn"
            :class="{ 'mobile-network-wallet__btn--connected': hasWallet }"
            @click="handleClickDropdown()"
        >
            <span v-if="!hasWallet">
                Network
                <img
                    src="/images/landing-page/icon-caret-down-white.svg"
                    alt="icon dropdown"
                    class="ms-1"
                />
            </span>
            <span v-else class="selected-network">
                <div class="selected-network__img">
                    <img
                        :src="pathIconName(selectedNetwork)"
                        alt="network icon"
                    />
                </div>
                {{ selectedNetwork }}
            </span>
        </div>
        <div
            class="mobile-network-wallet__dropdown"
            :class="{
                'mobile-network-wallet--active': isNetworkDropdownActive
            }"
        >
            <template v-if="getAvailableNetwork.length !== 0 && hasWallet">
                <div
                    class="mobile-network-wallet__dropdown-list"
                    v-for="(item, index) in getAvailableNetwork"
                    @click="switchNetwork(item)"
                    :key="`dropdown-list-${index}`"
                >
                    <div class="mobile-network-wallet__list-img">
                        <img
                            :src="pathIconName(item.name)"
                            alt="network icon"
                        />
                    </div>
                    <span>{{ item.name }}</span>
                </div>
            </template>
            <template v-else>
                <div class="mobile-network-wallet__dropdown-list">
                    <span style="font-size: 13px;">No wallet connected</span>
                </div>
            </template>
        </div>

        <b-modal ref="network-alert" centered hide-footer title="Network Alert">
            <div class="d-flex flex-column text-center">
                <div class="txt-btm-wlt">
                    The {{ switchText }} Network is not detected on your Wallet.
                    Please add {{ switchText }} Network first to switch.
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Web3 from "web3";
import WalletConnectProvider from "@walletconnect/web3-provider";

export default {
    data() {
        return {
            switchText: null,
            isNetworkDropdownActive: false
        };
    },
    computed: {
        ...mapGetters({
            hasWallet: "wallet/getHasWallet",
            walletProvider: "wallet/getWalletProvider",
            activeWeb3: "wallet/getActiveWeb3",
            selectedNetwork: "wallet/getSelectedNetwork",
            getAvailableNetwork: "vaults/getAvailableNetwork"
        }),
        canSwitchNetwork() {
            return this.walletProvider != "walletconnect" ? true : false;
        }
    },
    mounted() {},
    methods: {
        async changeChain(chainId) {
            await this.$store.dispatch("wallet/chainChanged", chainId);
        },
        isMobile() {
            if (screen.width <= 760) {
                return true;
            } else {
                return false;
            }
        },
        async switchNetwork({ value, text, rpc, url, token }) {
            if (this.walletProvider == "metamask") {
                try {
                    await ethereum
                        .request({
                            method: "wallet_switchEthereumChain",
                            params: [{ chainId: value }]
                        })
                        .then(result => {
                            this.changeChain(value);
                            if (this.isMobile()) {
                                this.$forceUpdate();
                            }
                        });
                } catch (err) {
                    if (err.code === 4902) {
                        try {
                            await ethereum.request({
                                method: "wallet_addEthereumChain",
                                params: [
                                    {
                                        chainId: value,
                                        chainName: text,
                                        rpcUrls: [rpc],
                                        blockExplorerUrls: [url],
                                        nativeCurrency: {
                                            name: token,
                                            symbol: token,
                                            decimals: 18
                                        }
                                    }
                                ]
                            });
                        } catch (err) {
                            // handle "add" error
                            this.$refs["network-alert"].show();
                        }
                    } else {
                        this.$refs["network-alert"].show();
                    }
                }

                // close the dropdown menu whatever the action is (add or switch)
                this.isNetworkDropdownActive = false;

                // } else if (this.walletProvider == "walletconnect") {
                //     try {
                //         await this.activeWeb3.eth.currentProvider
                //             .request({
                //                 method: "wallet_switchEthereumChain",
                //                 params: [{ chainId: value }]
                //             })
                //             .then(result => {
                //                 this.changeChain(value);
                //                 if (this.isMobile()) {
                //                     this.$forceUpdate();
                //                 }
                //             });
                //     } catch (err) {
                //         console.log(err);
                //         if (err.code === 4902) {
                //             try {
                //                 await this.activeWeb3.eth.currentProvider
                //                     .request({
                //                         method: "wallet_addEthereumChain",
                //                         params: [
                //                             {
                //                                 chainId: value,
                //                                 chainName: text,
                //                                 rpcUrls: [rpc],
                //                                 blockExplorerUrls: [url],
                //                                 nativeCurrency: {
                //                                     name: token,
                //                                     symbol: token,
                //                                     decimals: 18
                //                                 }
                //                             }
                //                         ]
                //                     });
                //             } catch (err) {
                //                 // handle "add" error
                //                 this.$refs["network-alert"].show();
                //             }
                //         } else {
                //             this.$refs["network-alert"].show();
                //         }
                //     }
            } else return;
        },
        handleClickDropdown() {
            if (this.canSwitchNetwork) {
                this.isNetworkDropdownActive = !this.isNetworkDropdownActive;
            }
        },
        pathIconName(name) {
            // let pngIcon = ["moonbeam"];
            // if (pngIcon.includes(name)) {
            //     return `/images/network-icons/rounded-glass/network-icon-${name}.png`;
            // }

            return `/images/network-icons/rounded-glass/network-icon-${name}.svg`;
        }
    }
};
</script>

<style lang="scss">
@import "./resources/sass/_variables.scss";
@import "bootstrap-vue/dist/bootstrap-vue.css";

.dropdown-item {
    @media only screen and (min-width: 1440px) {
        padding: 0.2777777777777778vw 1.6666666666666667vw;
    }
}

.my-dropdown {
    .btn,
    .dropdown-menu {
        /* font-size: 12px;
        line-height: 16px !important;
        padding: 4px 12px !important; */
        min-width: initial;
        padding: 0.2777777777777778vw 0;
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .network-connect {
        .my-dropdown {
            .btn,
            .dropdown-menu {
                font-size: 12px;
                line-height: 16px !important;
                padding: 4px 30px !important;
            }
        }
    }
}
.dropdown-menu {
    z-index: 999 !important;
    border-radius: 20px !important;
}
</style>

<style lang="scss" scoped>
button {
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin-left: auto;
}

.selected-network {
    .selected-network__img {
        margin-right: 10px;

        @media only screen and (min-width: 1440px) {
            margin-right: 0.6944444444444444vw;
        }

        img {
            margin-left: 0 !important;
        }
    }
}
</style>
